import logo from './logo.svg';
import './App.css';
import SimpleSlider from "./components/SimpleSlider"
import "../node_modules/slick-carousel/slick/slick.css"
import "../node_modules/slick-carousel/slick/slick-theme.css"
import './styles/app.scss';

//fonts
import "./fonts/VWHeadWeb-Bold.ttf";
import "./fonts/VWHeadWeb-BoldItalic.ttf";
import "./fonts/VWHeadWeb-ExtraBold.ttf";
import "./fonts/VWHeadWeb-Light.ttf";
import "./fonts/VWHeadWeb-Regular.ttf";
import "./fonts/VWHeadWeb-RegularItalic.ttf";
import "./fonts/VWTextWeb-Bold.ttf";
import "./fonts/VWTextWeb-BoldItalic.ttf";
import "./fonts/VWTextWeb-Medium.ttf";
import "./fonts/VWTextWeb-Light.ttf";
import "./fonts/VWTextWeb-Regular.ttf";
import "./fonts/VWTextWeb-RegularItalic.ttf";
import { AnimationOnScroll } from 'react-animation-on-scroll';



function App() {
  let darkModeFlag = window.matchMedia('(prefers-color-scheme: dark)').matches;
  let url = window.location.href;
  let lang = navigator.language;
  let langFlag = false;
  if(lang.toLowerCase().includes("fr")){
    langFlag=true;
  }
  if(url.endsWith("/fr") || url.endsWith("/fr/")){
    langFlag=true;
  }else if(url.endsWith("/en") || url.endsWith("/en/")){
    langFlag=false;
  }

  if(darkModeFlag){
      // vwdata.push({
      //   name: "Car Cover Page Load",
      //   pageName: "Side B - Dark",

        

      // });
  }else{
    // vwdata.push({
    //   name: "Car Cover Page Load",
    //   pageName: "Side A - Light",
      
    // });
  }
  

  return (
    
    <div className='container'>
      
      <SimpleSlider
        darkMode={darkModeFlag} 
        frMode={langFlag}

      />
    </div>
  );
}

export default App;


